import api from './api';
import { InvestorNote } from '../types/InvestorNote';

export const noteService = {
  getAllByInvestor: (investorId: string) =>
    api.get<InvestorNote[]>(`/investors/${investorId}/notes`),

  getById: (noteId: string) =>
    api.get<InvestorNote>(`/investors/notes/${noteId}`),

  create: (investorId: string, data: InvestorNote) =>
    api.post<InvestorNote>(`/investors/${investorId}/notes`, data),

  update: (noteId: string, data: InvestorNote) =>
    api.put<InvestorNote>(`/investors/notes/${noteId}`, data),

  delete: (noteId: string) =>
    api.delete(`/investors/notes/${noteId}`),
};
